import { getFilterIndicator } from "../helpers";

import type { FilterStrategy } from "./types";

/**
 * Fallback for filter types without explicit strategies (currently `select`).
 * Reproduces the generic "iterate options, match by label" search and the
 * simple "set to optionValue" toggle path that those types relied on in the
 * pre-strategy implementation.
 */
export const defaultStrategy: FilterStrategy = {
  search(filterType, ctx, out) {
    if (!filterType.options || filterType.options.length === 0) return;
    const q = ctx.query;
    for (const option of filterType.options) {
      if (option.label.toLowerCase().includes(q)) {
        const isExact = option.label.toLowerCase() === q;
        out.push({
          filterKey: filterType.filterKey,
          filterLabel: filterType.label,
          optionValue: option.value,
          optionLabel: option.label,
          type: filterType.type,
          score: isExact ? 90 : 70,
          indicator: getFilterIndicator(filterType),
        });
      }
    }
  },
  isSelected(currentValue, optionValue) {
    return currentValue === optionValue;
  },
  toggle(result) {
    return { value: result.optionValue };
  },
};
